<script setup lang="ts">
import type { PaginationRootEmits, PaginationRootProps } from 'reka-ui'
import { PaginationEllipsis, PaginationList, PaginationListItem, PaginationNext, PaginationPrev, PaginationRoot, useForwardPropsEmits } from 'reka-ui'
import { faArrowLeft, faArrowRight } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'

const props = defineProps<PaginationRootProps & { buttonColor?: string }>()
const emits = defineEmits<PaginationRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <PaginationRoot
    v-slot="{ page: currentPage }"
    v-bind="forwarded"
    :sibling-count="1"
    show-edges
  >
    <PaginationList
      v-slot="{ items }"
      class="flex items-center gap-2"
    >
      <PaginationPrev as-child>
        <Button
          size="lg"
          shape="square"
          variant="outline"
          :color="buttonColor"
        >
          <font-awesome-icon :icon="faArrowLeft" />
        </Button>
      </PaginationPrev>
      <template v-for="(page, index) in items">
        <PaginationListItem
          v-if="page.type === 'page'"
          :key="index"
          :value="page.value"
          as-child
        >
          <Button
            size="lg"
            shape="square"
            :color="buttonColor"
            :variant="page.value === currentPage ? 'solid' : 'outline'"
          >
            {{ page.value }}
          </Button>
        </PaginationListItem>
        <PaginationEllipsis
          v-else
          :key="page.type"
          :index="index"
          class="flex size-9 items-center justify-center"
        >
          &#8230;
        </PaginationEllipsis>
      </template>
      <PaginationNext as-child>
        <Button
          size="lg"
          shape="square"
          variant="outline"
          :color="buttonColor"
        >
          <font-awesome-icon :icon="faArrowRight" />
        </Button>
      </PaginationNext>
    </PaginationList>
  </PaginationRoot>
</template>
